// extracted by mini-css-extract-plugin
export var MousewheelSwiper = "index-module--MousewheelSwiper--XiCCJ";
export var MousewheelSwiperContainer = "index-module--MousewheelSwiperContainer--YANKG";